import { render, staticRenderFns } from "./CurrentBalances.vue?vue&type=template&id=66cdfb37&scoped=true&"
import script from "./CurrentBalances.vue?vue&type=script&lang=js&"
export * from "./CurrentBalances.vue?vue&type=script&lang=js&"
import style0 from "./CurrentBalances.vue?vue&type=style&index=0&id=66cdfb37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdfb37",
  null
  
)

export default component.exports